function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "5ufna",
  d: "M522.473 437a5.5 5.5 0 1 0-5.473-5.5 5.495 5.495 0 0 0 5.473 5.5z"
}), React.createElement("path", {
  id: "5ufnb",
  d: "M505.004 457.346l2.227-12.115h9.172l4.902 6.424c.257.337.66.536 1.09.536.428 0 .832-.199 1.088-.536l4.907-6.438h9.389l2.227 12.129zm7.63-25.418c.303-4.548 4.037-9.26 9.753-9.26s9.45 4.712 9.762 9.256a9.927 9.927 0 0 1-2.105 6.642l-7.657 10.066-7.658-10.066a9.927 9.927 0 0 1-2.104-6.642zm27.607 11.72a1.352 1.352 0 0 0-1.358-1.098h-8.481l1.81-2.388a12.562 12.562 0 0 0 2.643-8.416c-.448-6.58-5.924-11.746-12.468-11.746s-12.02 5.166-12.468 11.746a12.56 12.56 0 0 0 2.625 8.416l1.81 2.388h-8.26a1.352 1.352 0 0 0-1.357 1.098l-2.716 14.782c-.071.393.04.796.302 1.1.263.304.65.476 1.056.47h38.242c.406.006.793-.166 1.056-.47.263-.304.373-.707.302-1.1z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-502 -420)"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#5ufna"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#5ufnb"
})))));

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.f462cf06.svg";
export { ForwardRef as ReactComponent };